/**
 * Zzzing Land Owner API
 * Zzzing Land Owner API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OverallPerformance { 
    /**
     * Total contribution Earned to date
     */
    total_owner_contributions?: number;
    /**
     * Sum of upcoming contributions from future bookings
     */
    upcoming_contributions_reservations?: number;
    /**
     * Total funds transferred to date
     */
    total_funds_transferred?: number;
    /**
     * Pending balance with Zzzing
     */
    pending_balance?: number;
}

